// extracted by mini-css-extract-plugin
export default {"wrapper":"PV0yr0LKfmhjw7C7qpxI"};